import React from 'react';

import { Signature as StyledSignature } from './Signature.styles.js';
import SignaturePad from '../../components/SignaturePad';

import { useWindowDimensions } from '../../utils/windowDimensionSize.js';

function Signature({
	clear,
	save,
	undo,
	goBack,
	getCanvasRef,
	textCanvasRef,
	canvasOptions,
	signatureOptions,
	onChangeSignatureType,
	onChangeSignatureText,
	handleKeyDown,
	loading
}) {
	const { width } = useWindowDimensions();

	return (
		<StyledSignature className="doca">
			<StyledSignature.Container>
				<StyledSignature.Title>
					Assinar documento
				</StyledSignature.Title>

				<div className="doca-mt-6">
					<SignaturePad
						loading={loading}
						signatureType={signatureOptions.signature_type}
						signatureText={signatureOptions.signature_text}
						onChangeSignatureType={onChangeSignatureType}
						onChangeSignatureText={onChangeSignatureText}
						handleKeyDown={handleKeyDown}
						canvasOptions={canvasOptions}
						getCanvasRef={getCanvasRef}
						textCanvasRef={textCanvasRef}
						onClear={clear}
						onUndo={undo}
					/>
				</div>

				{width >= 600 && (
					<StyledSignature.Footer>
						<button className="doca-button doca-button--block doca-button--secondary" onClick={goBack}>
							Voltar
						</button>
						<button className="doca-button doca-button--block doca-button--primary" disabled={loading} onClick={save}>
							Salvar assinatura
						</button>
					</StyledSignature.Footer>
				)}
			</StyledSignature.Container>

			{width < 600 && (
				<StyledSignature.FooterContainer className="doca-w-full doca-p-4 doca-bg-white">
					<div className="doca-flex doca-flex-col doca-gap-2 doca-w-full doca-mt-2">
						<button className="doca-button doca-button--block doca-button--secondary" onClick={goBack}>
							Voltar
						</button>
						<button className="doca-button doca-button--block doca-button--primary" disabled={loading} onClick={save}>
							Salvar assinatura
						</button>
					</div>
				</StyledSignature.FooterContainer>
			)}
		</StyledSignature>
	);
}

export default Signature;
